import { render, staticRenderFns } from "./SalesUserDistributor.vue?vue&type=template&id=56d958ff&"
import script from "./SalesUserDistributor.vue?vue&type=script&lang=js&"
export * from "./SalesUserDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports